<template>
    <div>
        <v-btn-toggle v-model="banner_top"  v-if="permission.write?true:false">
            <v-btn flat value="image">
                Imagem
            </v-btn>
            <v-btn flat value="slider">
                Slider
            </v-btn>
        </v-btn-toggle>

        <fluke-bigslider
            v-model="sliders"
            v-show="banner_top=='slider'"
            :disabled="permission.write?null:true"
            :key="sliderkey" />

        <fluke-imageuploader
            v-model="img"
            :disabled="permission.write?null:true"
            v-show="banner_top=='image'" />
    </div>
</template>

<script>
import flukeBigslider from '../../../components/Main/Content/BigSlider/BigSlider';
import flukeImageuploader from '../../../components/Main/Content/ImageUploader/ImageUploader';
import permission from '../../../mixins/permissions';


export default {
    mixins: [ permission ],
    components: {
        flukeBigslider,
        flukeImageuploader,
    },
    data()
    {
        return {
            permission: false,
            sliderkey: 0,
            banner_top: 'slider',
            sliders: [],
            img: ''
        }
    },
    computed: {
        pageImg() {
            return this.$store.state.page.img;
        },
    },
    watch: {
        pageImg() {
            if( this.pageImg ) {
                if( this.pageImg.indexOf('[') === -1 ) {
                    this.img = this.pageImg;
                    this.banner_top = 'image';
                } else {
                    this.sliders = JSON.parse( this.pageImg );
                    this.banner_top = 'slider';
                }
            }
        }
    },
    created()
    {
        this.permission = this.getUserPagePermission('pages');
		if( this.permission.read == false ) {
			this.$router.push('/');
        }
    },
    methods: {
        updateStoreImg()
        {
            var data = '';
            if( this.banner_top == 'slider' ) {

                data = JSON.stringify( this.sliders );
            } else {

                data = this.img;
            }
            this.$store.commit( 'set_pagedata', {
                field: 'img',
                data
            });
        }
    }
}
</script>